import { useState } from "react";
import AssignmentList from "@admin/components/Assignments/AssignmentList";
import AssignmentModal from "@admin/components/Modals/AssignmentModal";

const Assignment = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  function closeModal() {
    setIsModalOpen(false);
  }

  return (
    <div className="px-3 py-20 bg-opacity-10">
      <div className="w-full flex">
        <button className="btn ml-auto" onClick={openModal}>
          Add Assignment
        </button>
        <AssignmentModal open={isModalOpen} closeModal={closeModal} />
      </div>
      <AssignmentList />
    </div>
  );
};

export default Assignment;
